import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccCpsRate = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.CPS_RATE',
  });
  return result;
};
